import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { Chat } from 'src/apis'

export const useBrandChatbotStore = defineStore('BrandChatbot', () => {
  const isBrand = ref(false)
  const notificationTime = ref(0)
  const branchChatCount = ref(0)

  const chatCount = computed(() => {
    const branchCount = branchChatCount.value
    if (branchCount >= 0 && branchCount < 10) {
      return branchCount
    } else {
      return branchCount < 0 ? 0 : 9
    }
  })

  function setIsBrand(value) {
    isBrand.value = value
  }

  function setNotificationTime(value) {
    notificationTime.value = value
  }

  function setBranchChatCount(value) {
    branchChatCount.value = value
  }

  function fetchBranchCount(chatID) {
    Chat.GetBranchChatsCount(chatID).then((response) => {
      setBranchChatCount(response.count)
    })
  }

  return {
    isBrand,
    notificationTime,
    branchChatCount,
    chatCount,
    setIsBrand,
    setBranchChatCount,
    setNotificationTime,
    fetchBranchCount
  }
})
